module.exports = __webpack_public_path__ + "static/media/delete (1).c51302d3.svg";